import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchBouncedReceipt } from '../../../../actions/bouncedReceipt/bouncedReceiptDetail'
import { AppState } from '../../../../reducers'
import { BouncedReceiptDetailState } from '../../../../reducers/bouncedReceipt/bouncedReceiptDetail'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack, TableContainer, Table, TableHead, TableRow, TableBody, TableCell } from '@mui/material';
import { KeyboardReturnOutlined, LaunchOutlined } from '@mui/icons-material';
import moment from 'moment';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { ISTableHeaderCell, ISTableRow, ISTableTitle } from '../../../Utils/ISTable'
import { SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'

interface Props {
  bouncedReceiptDetail: BouncedReceiptDetailState
  session: SessionState
}

const BouncedReceiptDetail: React.FC<Props> = ({ session, bouncedReceiptDetail }) => {
  const dispatch = useDispatch()
  const params = useParams<{ bouncedReceiptId?: string, sucursal?: string, numero?: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['invoice', 'others'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchBouncedReceipt(params.bouncedReceiptId ? params.bouncedReceiptId : '', params.clientId ? params.clientId : '',
      params.sucursal ? params.sucursal : '', params.numero ? params.numero : '', history.location.search))
  }, [dispatch, params.bouncedReceiptId, params.sucursal, params.numero, params.clientId, history.location.search])



  const linkToInvoiceDetail = (invoiceId: string) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/accounts/detail/${invoiceId}`
    history.push(detailUrl)
  }

  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        {bouncedReceiptDetail.bouncedReceiptLines && bouncedReceiptDetail.bouncedReceiptLines.length > 0 &&
          <Paper elevation={2}
            style={{
              padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
              textAlign: "justify", justifyContent: "space-around",
              borderRadius: "4px", margin: "4px"
            }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('invoice')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{bouncedReceiptDetail.bouncedReceiptLines[0].tipo}&nbsp;
                  {bouncedReceiptDetail.bouncedReceiptLines[0].sucursal.toString().padStart(4, '0')}-
                  {bouncedReceiptDetail.bouncedReceiptLines[0].numero.toString().padStart(8, '0')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('date')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(bouncedReceiptDetail.bouncedReceiptLines[0].fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('costId')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center'}}>{bouncedReceiptDetail.bouncedReceiptLines[0].comprobante_de_gastos_asociado}&nbsp;&nbsp;
                  <LaunchOutlined sx={{ cursor: 'pointer', color: theme.palette.success.main }}
                    onClick={() => linkToInvoiceDetail(bouncedReceiptDetail.bouncedReceiptLines![0].comprobante_de_gastos_asociado)} />
                </Typography>
              </Box>
              {/*
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('costs')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(bouncedReceiptDetail.bouncedReceiptLines[0].importe_gastos)}</Typography>
              </Box>*/}
            </Box>
            {/*<Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">&nbsp;</Typography>
                <Typography variant="h6">&nbsp;</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('total')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(bouncedReceiptDetail.bouncedReceiptLines[0].importe_total)}</Typography>
              </Box>
            </Box>*/}
          </Paper>}
      </Paper >
    )
  }

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <Stack style={{ display: 'flex', flexDirection: 'column', height: '80%', borderRadius: "10px", margin: "10px", minWidth: "500px" }}>
        <ISTableTitle title={t('titleDetail')} />
        <TableContainer sx={{ overflowX: 'auto', height: '100%' }}>
          <Table size="medium" stickyHeader >
            <TableHead>
              <TableRow selected={true}>
                <ISTableHeaderCell align='center'>{t('check')}</ISTableHeaderCell>
                <ISTableHeaderCell>{t('bank')}</ISTableHeaderCell>
                <ISTableHeaderCell>{t('reasonRejection')}</ISTableHeaderCell>
                <ISTableHeaderCell align='center'>{t('dueDate')}</ISTableHeaderCell>
                <ISTableHeaderCell align='right'>{t('value')}</ISTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bouncedReceiptDetail.bouncedReceiptLines && bouncedReceiptDetail.bouncedReceiptLines.length > 0 &&
                <ISTableRow color='default' key={bouncedReceiptDetail.bouncedReceiptLines[0].numero}>
                  <TableCell align='center'>{bouncedReceiptDetail.bouncedReceiptLines[0].numero_de_cheque}</TableCell>
                  <TableCell>{bouncedReceiptDetail.bouncedReceiptLines[0].banco}</TableCell>
                  <TableCell>{bouncedReceiptDetail.bouncedReceiptLines[0].motivo_de_rechazo}</TableCell>
                  <TableCell align='center'>{moment(bouncedReceiptDetail.bouncedReceiptLines[0].vencimiento).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
                  <TableCell align='right'>{formattedCurrency(bouncedReceiptDetail.bouncedReceiptLines[0].importe_cheque)}</TableCell>
                </ISTableRow>}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  bouncedReceiptDetail: state.bouncedReceiptDetail,
  session: state.session
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(BouncedReceiptDetail);